var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaLineBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 103,
    viewBox: "0 0 4 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "rotate(-180 2 2)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 3,
    y: 103,
    width: 2,
    height: 100,
    transform: "rotate(-180 3 103)",
    fill: "url(#paint0_linear_37_143)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_143",
    x1: 4,
    y1: 103,
    x2: 4,
    y2: 203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLineBottom);
export default __webpack_public_path__ + "static/media/media-line-bottom.4667a8c8e9908d1a510f7a6f92fb4837.svg";
export { ForwardRef as ReactComponent };